import { useState } from 'react'

import { ModalBody, ModalContainer, ModalFooter, ModalHeader, ModalHeaderContainer } from '@apps-common/components/modals/modal'
import { commonIcons } from '@apps-common/config/icons'
import { ModalDismiss } from '@apps-common/config/modal'

import { ISelectOption } from '@apps-common/types/form'
import { ButtonRounded, CheckboxInputSM } from '../elements'

declare global {
  interface Navigator {
    msSaveBlob?: (blob: any, defaultName?: string) => string
  }
}

export interface IKeyValueCheckboxModal {
  keyValues?: ISelectOption[]
}

export const KeyValueCheckboxModal = ({
  onDismiss,
  componentProps
}: {
  onDismiss: (data?: string | null | undefined | number, role?: string) => void
  componentProps: IKeyValueCheckboxModal
}) => {
  const keyValues = componentProps?.keyValues || []
  const [selections, setSelections] = useState<ISelectOption[]>(keyValues)

  return (
    <ModalContainer innerClasses='sm:!h-auto !max-w-[1000px]'>
      <ModalHeaderContainer>
        <div className='flex items-start justify-between'>
          <ModalHeader subtitle='Selection' title='Export' titleClasses='flex flex-col' subtitleClasses='capitalize' />
          <div className='flex items-center gap-[10px]'>
            <button
              type='button'
              aria-label='Close filter'
              className='bg-secondary-content/5 text-secondary-content text-[1.2em] w-[35px] h-[35px] rounded-full flex items-center justify-center'
              onClick={() => {
                onDismiss(null, ModalDismiss.Cancel)
              }}
            >
              <commonIcons.close />
            </button>
          </div>
        </div>
        <button
          type='button'
          aria-label='Toggle all'
          className='jost px-[0px] pt-[10px] text-[0.8em] underline'
          onClick={() => {
            if (selections?.length != keyValues?.length) {
              setSelections(keyValues)
            } else {
              setSelections([])
            }
          }}
        >
          Toggle all
        </button>
      </ModalHeaderContainer>
      <ModalBody classes='!pt-[120px] !pb-[80px]'>
        <div className='grid sm:grid-cols-2 md:grid-cols-3 gap-x-[30px] sm:gap-y-[10px]'>
          {keyValues?.map((k, i) => (
            <div>
              <CheckboxInputSM
                label={k.label}
                id={`exportkey-value-${k}`}
                key={`export-${k}`}
                disabled={false}
                registration={{
                  checked: !!selections?.find((s) => s.value === k.value),
                  onClick: (e: any) =>
                    setSelections((prev) => {
                      const exists = prev?.find((s) => s.value === k.value)
                      if (exists) {
                        return prev?.filter((s) => s.value !== k.value)
                      } else {
                        return [...(prev || []), k]
                      }
                    })
                }}
              />
            </div>
          ))}
        </div>
      </ModalBody>
      <ModalFooter>
        <div className='flex items-center justify-start gap-2'>
          <ButtonRounded
            type='button'
            loading={selections.length === 0}
            text='Done'
            className='!h-[30px] min-h-0 !min-w-[120px] mt-0 !w-auto'
            callback={() => onDismiss(JSON.stringify(selections), ModalDismiss.Confirm)}
          />
          <ButtonRounded
            type='button'
            loading={false}
            text='Cancel'
            className='!h-[30px] min-h-0 !min-w-[120px] mt-0 !w-auto'
            callback={() => onDismiss(null, 'cancel')}
          />
        </div>
      </ModalFooter>
    </ModalContainer>
  )
}
